/**
 * This package provides functionality for working with
 * {@link https://www.w3.org/TR/wai-aria/ | ARIA} and the accessibility tree.
 *
 * @packageDocumentation
 */
import * as dom from "./dom/dom.js";
export * from "./attribute.js";
export * from "./feature.js";
export * from "./name/index.js";
export * from "./role.js";
export * from "./node.js";
export * from "./node/container.js";
export * from "./node/element.js";
export * from "./node/inert.js";
export * from "./node/text.js";
/**
 * Helpers and Predicates for accessibility aspects of DOM objects
 *
 * @public
 */
export var DOM;
(function (DOM) {
    DOM.hasAccessibleName = dom.hasAccessibleName, DOM.hasExplicitRole = dom.hasExplicitRole, DOM.hasHeadingLevel = dom.hasHeadingLevel, DOM.hasImplicitRole = dom.hasImplicitRole, DOM.hasIncorrectRoleWithoutName = dom.hasIncorrectRoleWithoutName, DOM.hasNonDefaultRole = dom.hasNonDefaultRole, DOM.hasNonEmptyAccessibleName = dom.hasNonEmptyAccessibleName, DOM.hasRole = dom.hasRole, DOM.isIgnored = dom.isIgnored, DOM.isIncludedInTheAccessibilityTree = dom.isIncludedInTheAccessibilityTree, DOM.isMarkedDecorative = dom.isMarkedDecorative, DOM.isPerceivableForAll = dom.isPerceivableForAll, DOM.isProgrammaticallyHidden = dom.isProgrammaticallyHidden, DOM.isSemanticallyDisabled = dom.isSemanticallyDisabled;
})(DOM || (DOM = {}));
//# sourceMappingURL=index.js.map